import Vue from 'vue';
import {vrmVueModule} from '@/angular-bridge/module';

/*

This is the briding code to shim vue-router on the angular base application
It adds the following vue-router API to use in all vue components:

vm.$router
vm.$route

Caveats:
- Route objects do not have `query` fields populated, those resolved through the ui.router module end up in `$route.params`
- To use url query args in a vue component define the route template with ?x to populate `x` in the param hash

*/

vrmVueModule.run(/* @ngInject */ ($state, $rootScope) => {
    // Object acting as observable source of truth
    const source = Vue.observable({
        name: '',
        params: null,
        path: '',
        fullPath: '',
        matched: [],
    });

    // Vue-router API
    Vue.prototype.$router = {
        push(route) {
            if (typeof route === 'string') {
                route = {name: route, params: undefined};
            }
            $state.go(route.name, route.params, {location: true});
        },
        replace(route) {
            if (typeof route === 'string') {
                route = {name: route, params: undefined};
            }
            $state.go(route.name, route.params, {location: 'replace'});
        },
        back() {
            window.history.back();
        },
        get currentRoute() {
            return {
                get path() {
                    return source.path;
                },
                get params() {
                    return {...source.params};
                },
                get query() {
                    return {};
                },
                get hash() {
                    return '';
                },
                fullPath() {
                    return source.fullPath;
                },
                get matched() {
                    return source.matched;
                },
                get name() {
                    return source.name;
                },
                get redirectedFrom() {
                    return null;
                },
            };
        }
    };
    Object.defineProperty(Vue.prototype, '$route', {
        get() {
            return this.$router.currentRoute;
        }
    });

    // Angular to vue bridging code
    function updateRouterState() {
        const current = $state.$current;
        source.name = current.self.name;
        source.params = {...$state.params};
        source.path = $state.href(current);
        source.fullPath = $state.href(current, null, {absolute: true});
        source.matched = current.path.slice(1).map(segment => ({
            path: segment.path,
            component: getSegmentComponent(segment),
            name: segment.name,
            components: getSegmentComponents(segment),
            meta: {
                angularViews: Object.keys(segment.views),
            },
        }));
    }

    function getSegmentComponent(segment) {
        const names = Object.keys(segment.views);
        if (names.length === 1) {
            return segment.views[names[0]].originalVueComponent;
        } else if (segment.views.default) {
            return segment.views.default.originalVueComponent;
        } else {
            return null;
        }
    }

    function getSegmentComponents(segment) {
        const result = {};
        Object.keys(segment.views).map(viewName => {
            const view = segment.views[viewName];
            if (view.originalVueComponent) {
                result[viewName] = view.originalVueComponent;
            }
        });
        return result;
    }

    $rootScope.$on('$stateChangeSuccess', updateRouterState);
});

// Register components so they are globally available
import RouterLink from '@/vue/components/vue-router-shim/RouterLink';
import RouterView from '@/vue/components/vue-router-shim/RouterView';

Vue.component('router-link', RouterLink);
Vue.component('router-view', RouterView);
